import { render, staticRenderFns } from "./SegurStats.vue?vue&type=template&id=3ce69f34&scoped=true"
import script from "./SegurStats.vue?vue&type=script&lang=js"
export * from "./SegurStats.vue?vue&type=script&lang=js"
import style0 from "./SegurStats.vue?vue&type=style&index=0&id=3ce69f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce69f34",
  null
  
)

export default component.exports